export const passFailState = {
  pass: false,
  fail: false,
  skip: false
}

export const passFailMutations = {
  pass (state) {
    state.pass = true
    state.fail = false
    state.skip = false
  },

  fail (state) {
    state.pass = false
    state.fail = true
    state.skip = false
  },

  skip (state) {
    state.pass = false
    state.fail = false
    state.skip = true
  },

  reset (state) {
    state.pass = false
    state.fail = false
    state.skip = false
  }
}

